import { useSelector, useDispatch } from 'react-redux'
import { Dropdown, DropdownOption, InputWithFloatingLabel, FloatingLabel } from '@vp/swan'

import { currentPageSelector, currentPageSizeSelector, pageSizeAndContentUpdate, pageSizeOptionsSelector } from 'client/store/paging'
import { useTranslations } from 'client/hooks/useTranslations'
import { scrollUpToElement } from 'client/utils/scrollToElement'
import { galleryHeaderId } from 'client/components/Gallery/Header/constants'
import { ThunkDispatch } from 'client/store/interface'

interface PropTypes {
  className?: string
}

export const PerPage = (props: PropTypes) => {
  const { className } = props
  const localize = useTranslations()
  const dispatch = useDispatch<ThunkDispatch>()
  const pageSizeOptions = useSelector(pageSizeOptionsSelector)
  const page = useSelector(currentPageSelector)
  const pageSize = useSelector(currentPageSizeSelector)
  const pageSizeStringValue = pageSize.toString()

  const onPageSizeChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    event.preventDefault()

    const newSize = parseInt(event.currentTarget.value, 10)

    dispatch(pageSizeAndContentUpdate(page, pageSize, newSize))
    scrollUpToElement(galleryHeaderId)
  }

  return (
    <section className={className || 'perpage'}>
      <InputWithFloatingLabel>
        <FloatingLabel>{localize('DesignsPerPage')}</FloatingLabel>
        <Dropdown value={pageSizeStringValue} onChange={onPageSizeChange}>
          {pageSizeOptions.map((pageSizeOption: number) => {
            const pageSizeOptionStringValue = pageSizeOption.toString()

            return (
              <DropdownOption aria-selected={pageSizeStringValue === pageSizeOptionStringValue} key={pageSizeOption} value={pageSizeOption}>
                {localize('PerPageSelection', {
                  size: pageSizeOptionStringValue,
                })}
              </DropdownOption>
            )
          })}
        </Dropdown>
      </InputWithFloatingLabel>
    </section>
  )
}

PerPage.displayName = 'PerPage'
